import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { NavLink, Link } from 'react-router-dom';
import $ from 'jquery';
import lastOperationsIcon from '../img/last-operations-icon.png';
import transferConfirmation from '../img/transfer-confirmation.svg';
import Dropdown from '../../../copms/Dropdown/Dropdown';
import { request } from '../../../config';
import { getFormatedDate } from '../../../helpers/fotmatDate';
import AsanVerification from '../../../copms/Modal/AsanVerification';
import Loading from '../Loading/Loading';
import GuaranteeDetailsModal from '../../../copms/Modal/GuaranteeDetailsModal';

function base64ToArrayBuffer(base64) {
    let binaryString = window.atob(base64);
    let binaryLen = binaryString.length;
    let bytes = new Uint8Array(binaryLen);
    for (let i = 0; i < binaryLen; i++) {
        let ascii = binaryString.charCodeAt(i);
        bytes[i] = ascii;
    }
    return bytes;
}
function saveFile(name, type, data) {
    if (data !== null && navigator.msSaveBlob)
        return navigator.msSaveBlob(new Blob([data], { type: type }), name);
    var a = $("<a style='display: none;'/>");
    var url = window.URL.createObjectURL(new Blob([data], { type: type }));
    a.attr("href", url);
    a.attr("download", name);
    $("body").append(a);
    a[0].click();
    window.URL.revokeObjectURL(url);
    a.remove();
}

class List extends Component {
    state = {
        status: 1,
        toDate: null,
        fromDate: null,
        warrantyList: [],
        id: null,
        verificationOpen: false,
        verificationCode: null,
        statuses: [],
        open: false,
        item: null,
        invoice: null,
        isLoading: false,
        openDetails: false,
        link: 'active'
    }

    updateDate = (name, value) => {
        this.setState({ [name]: value });
    };

    componentDidMount() {
        this.getWarranty();
    }

    getWarranty = () => {
        this.setState({ isLoading: true });
        let { link } = this.state;
        let getWarrantyInfoRequestBody = {
            token: localStorage.getItem('token')
        }
        if (link === 'refusals') {
            getWarrantyInfoRequestBody.statusId = 7;
        }
        fetch(request(`warranty/getWarranty${link === 'active' ? 'Info' : 'Order'}`, getWarrantyInfoRequestBody))
            .then(res => res.text())
            .then((getWarrantyInfoResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getWarrantyInfoResponse = JSON.parse(getWarrantyInfoResponseJSON);
                if (getWarrantyInfoResponse.status.statusCode !== 1) {
                    if (getWarrantyInfoResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getWarrantyInfoResponse.status.statusCode));
                        this.setState({ isLoading: false });

                    }
                }
                this.setState({ warrantyList: getWarrantyInfoResponse.respWarrantyDetails ?? [] });
                this.setState({ isLoading: false });

            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getWarrantyDetail = (id) => {
        // if (this.state.link !== 'refusals') {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getWarrantyDetailRequestBody = {
            token: localStorage.getItem('token'),
            id
        }
        fetch(request(`warranty/${this.state.link === 'active' ? 'getWarrantyDetail' : 'getOrderDetail'}`, getWarrantyDetailRequestBody))
            .then(res => res.text())
            .then((getWarrantyDetailResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getWarrantyDetailResponse = JSON.parse(getWarrantyDetailResponseJSON);
                if (getWarrantyDetailResponse.status.statusCode !== 1) {
                    if (getWarrantyDetailResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getWarrantyDetailResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    if (this.state.link === 'active') {
                        let getFileRequestBody = {
                            token: localStorage.getItem('token'),
                            warrantyId: id
                        }
                        fetch(request("warranty/getWarrantyDocument", getFileRequestBody))
                            .then(res => res.text())
                            .then((getFileResponseJSON) => {
                                const JSON = require('true-json-bigint');
                                let getFileResponse = JSON.parse(getFileResponseJSON);
                                if (getFileResponse.status.statusCode !== 1) {
                                    if (getFileResponse.status.statusCode === 200) {
                                        this.props.logout();
                                    } else {
                                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getFileResponse.status.statusCode));
                                        this.props.updateAppState('isLoadingTransparentBackground', false);
                                    }
                                }
                                else {
                                    this.props.updateAppState('isLoadingTransparentBackground', false);
                                    this.setState({ openDetails: true, item: { ...getWarrantyDetailResponse, id, files: getFileResponse.warrantyFileList } })
                                }
                            },
                                (error) => {
                                    this.props.history.push("/technical-break");
                                });
                    } else {
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                        this.setState({ openDetails: true, item: { ...getWarrantyDetailResponse, id } })
                    }
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
        // }
    }

    getFile = (id) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let getFileRequestBody = {
            token: localStorage.getItem('token'),
            id
        }
        fetch(request("warranty/getWarrantyDocument", getFileRequestBody))
            .then(res => res.text())
            .then((getFileResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getFileResponse = JSON.parse(getFileResponseJSON);
                if (getFileResponse.status.statusCode !== 1) {
                    if (getFileResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getFileResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    getFileResponse.warrantyFileList.forEach((file) => {
                        let arrrayBuffer = base64ToArrayBuffer(file.fileContent);
                        saveFile(file.fileName, `application/${file.fileExtension.split(".").pop()}`, arrrayBuffer)
                    });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    getSignFile = (orderId) => {
        this.props.updateAppState('isLoadingTransparentBackground', true);
        let customerType = localStorage.getItem('compId') === null ? 'Individual' : 'Juridical';
        let certCode = customerType == 'Juridical' ? JSON.parse(localStorage.getItem('custObject')).company.certCode : JSON.parse(localStorage.getItem('custObject')).certCode
        let getSignFileRequestBody = {
            orderId,
            token: localStorage.getItem('token'),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
            certCode: certCode,
            userId: localStorage.getItem('userId'),
            phoneNumber: localStorage.getItem('phoneNumber')
        }
        fetch(request("warranty/getSignFileWarranty", getSignFileRequestBody))
            .then(res => res.text())
            .then((getSignFileResponseJSON) => {
                const JSON = require('true-json-bigint');
                let getSignFileResponse = JSON.parse(getSignFileResponseJSON);
                if (getSignFileResponse.status.statusCode !== 1) {
                    if (getSignFileResponse.status.statusCode === 200) {
                        this.props.logout();
                    } else {
                        this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(getSignFileResponse.status.statusCode));
                        this.props.updateAppState('isLoadingTransparentBackground', false);
                    }
                }
                else {
                    this.setState({ verificationOpen: true, verificationCode: getSignFileResponse.verificationCode })
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                    let signFileRequestBody = {
                        orderId,
                        token: localStorage.getItem('token'),
                        lang: localStorage.getItem('i18nextLng').toUpperCase(),
                        transactionId: getSignFileResponse.transactionId,
                        certCode: certCode,
                        userId: localStorage.getItem('userId'),
                        phoneNumber: localStorage.getItem('phoneNumber')
                    }
                    fetch(request("warranty/signFileWarranty", signFileRequestBody))
                        .then(res => res.text())
                        .then((signFileResponseJSON) => {
                            const JSON = require('true-json-bigint');
                            let signFileResponse = JSON.parse(signFileResponseJSON);
                            if (signFileResponse.status.statusCode !== 1) {
                                if (signFileResponse.status.statusCode === 200) {
                                    this.props.logout();
                                } else {
                                    this.setState({ verificationOpen: false });
                                    this.props.alertState(true, 'error', this.props.t('an error occurred'), this.props.t(signFileResponse.status.statusCode));
                                }
                            } else {
                                this.setState({ verificationOpen: false });
                                this.props.alertState(true, 'success', this.props.t('successful operation'), this.props.t(signFileResponse.status.statusCode), null, null, () => this.props.history.push('/dashboard/guarantees/list/active'));
                            }
                        });
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    dropdownItemHandler = (index, item) => {
        switch (index) {
            case 0:
                this.getWarrantyDetail(item.id)
                break;
            case 1:
                if (item.statusId == 0) {
                    this.props.history.push(`/dashboard/guarantees/create/${item.id}`)
                } else {
                    localStorage.getItem("isAsan") === "true" ?
                        this.getSignFile(item.id)
                        : this.props.alertState(true, 'warning', null, this.props.t('log in with Asan İmza'))
                }
                break;
            case 2:
                this.getFile(item.id)
                break;
            default: break;
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            this.setState({ link: window.location.pathname.split('/')[4] }, () => this.getWarranty())
        }
    }

    componentDidMount = () => {
        this.setState({ link: window.location.pathname.split('/')[4] }, () => this.getWarranty())
    }

    render() {
        let { warrantyList, link, verificationOpen, verificationCode, isLoading, openDetails, item } = this.state;
        let { t } = this.props;
        return (
            <>
                <AsanVerification open={verificationOpen} verificationCode={verificationCode} />
                <GuaranteeDetailsModal open={openDetails} item={item} triggerFunc={(id) => this.getFile(id)} closeFunction={() => this.setState({ openDetails: false })} />
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{t('Guarantees')}</h2>
                    </div>
                    <Link to='/dashboard/guarantees/create' class="dashboard-header-route-button">{t('Create guarantee')}</Link>
                </div>
                <div className="dashboard-salary-container flex-wrap">
                    <div className="dashboard-payment-container-data-section">
                        <div className="dashboard-transfer-list-header">
                            <div className="dashboard-transfer-list-header-container dashboard-transfer-list-header-container__left">
                                <NavLink exact to="/dashboard/guarantees/list/active" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("active")}</NavLink>
                                <NavLink exact to="/dashboard/guarantees/list/orders" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("orders")}</NavLink>
                                <NavLink exact to="/dashboard/guarantees/list/refusals" className="dashboard-transfer-list-header-link" activeClassName="dashboard-transfer-list-header-container dashboard-transfer-list-header-link__active">{t("refusal")}</NavLink>
                            </div>
                        </div>
                        <div className="dashboard-salary-order-container">
                            {isLoading ? <Loading /> : warrantyList.length === 0 ?
                                <div className="dashboard-last-operations-section-content" style={{ justifyContent: 'center' }}>
                                    <img src={lastOperationsIcon} className="dashboard-last-operations-section-content-image" alt="lastOperationsIcon" />
                                    <p className="dashboard-last-operations-section-content-status">{t('Məlumat yoxdur')}</p>
                                </div>
                                : <><div style={{ height: "50vh", overflowY: "auto", overflowX: 'auto', width: "100%" }}>
                                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                                        <thead style={{ position: 'sticky', top: 0, left: 0, zIndex: '100' }}>
                                            <tr className='border-0'>
                                                <th>{t("category")}</th>
                                                <th>{t("branch")}</th>
                                                <th>{t("Opening date")}</th>
                                                <th>{t("Amount")}</th>
                                                <th>{t("currency")}</th>
                                                {link === 'refusals' && <th>{t("Cancellation date")}</th>}
                                                {link === 'orders' && <>
                                                    <th>{t("Status")}</th>
                                                    <th></th>
                                                </>}
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {warrantyList.map(item => (
                                                <tr onClick={e => link === 'active' && this.getWarrantyDetail(item?.id)} style={{ cursor: link === 'active' ? 'pointer' : 'default' }}>
                                                    <td>{item.warrantyType || '--'}</td>
                                                    <td>{item.branchName || '--'}</td>
                                                    <td>{item.warrantyDate ? getFormatedDate(item.warrantyDate, 'dd.mm.yyyy') : '--'}</td>
                                                    <td>{item.warrantyAmount || '--'}</td>
                                                    <td>{item.currency || '--'}</td>
                                                    {link === 'refusals' && <td>{item.rejectDate ? getFormatedDate(item.rejectDate, 'dd.mm.yyyy') : '--'}</td>}
                                                    {link === 'orders' &&
                                                        <>
                                                            <td>
                                                                <div className='d-flex align-items-center'>
                                                                    <span style={{ width: '8px', height: '8px', display: 'inline-block', marginRight: 7, borderRadius: '50%', backgroundColor: item.statusId == 0 ? "#f12727" : item.statusId == 1 ? "#276EF1" : item.statusId == 3 ? "#FFAB24" : "#39C045" }}></span>
                                                                    {item.statusId == 0 ? t('Not completed') : item.statusId == 1 ? t('on hold') : item.statusId == 3 ? t('Signature is pending') : t('In execution')}
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="dashboard-finance-section-cards-section-button-group">
                                                                    <Dropdown className="center"
                                                                        dropdownItems={
                                                                            item.statusId == 3
                                                                                ? [
                                                                                    { title: this.props.t('Guarantee details') },
                                                                                    { title: this.props.t('Sign with Asan') },
                                                                                    { title: this.props.t('Contract') }
                                                                                ] : item.statusId == 0 ?
                                                                                    [{ title: this.props.t('Guarantee details') },
                                                                                    { title: this.props.t('Complete guarantee') }]
                                                                                    : [{ title: this.props.t('Guarantee details') }]
                                                                        }
                                                                        dropdownItemHandler={(i) => this.dropdownItemHandler(i, item)} />
                                                                </div>
                                                            </td>
                                                        </>
                                                    }
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div></>
                            }
                        </div>
                    </div>
                    <div className="dashboard-payment-container-confirmation-section">
                        <div className="dashboard-payment-container-confirmation-section-header">
                            <h3 className="dashboard-payment-container-confirmation-section-header-title">{t('Information')}</h3>
                        </div>
                        <div className="dashboard-payment-container-confirmation-section-content">
                            <img src={transferConfirmation} alt="img" className="dashboard-payment-container-confirmation-section-content-image" />
                            <div className="dashboard-payment-container-confirmation-section-content-description">
                                <p>{t('guarantee text')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}

export default translate("translation")(List);